import React from 'react';
import { createRoot } from 'react-dom/client';
import RootComponent from './Render/RootComponent';

export const renderApp = (rootId: string, globalData: GlobalData) => {
    const rootEle = document.getElementById(rootId);
    if (rootEle) {
        createRoot(rootEle).render(<RootComponent globalData={globalData} />);
    } else {
        console.error('react root element not found');
    }
};
